import { Component, Input } from '@angular/core';
import { PlaneLoaderComponent } from '../plane-loader/plane-loader.component';

@Component({
  selector: 'app-plane-spinner',
  templateUrl: './plane-spinner.component.html',
  styleUrl: './plane-spinner.component.css',
  imports: [PlaneLoaderComponent],
  standalone: true,
})
export class PlaneSpinnerComponent {
  @Input() showLoading: boolean = true;
}
